export function environmentLabel(value: string | undefined): string {
  const normalized = value?.trim();
  if (!normalized) return "Unknown";
  return normalized
    .split(/[\s_-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(" ");
}

export function isProductionEnvironment(value: string | undefined): boolean {
  return value?.trim().toLowerCase() === "production";
}
